<template>
  <div class="text-left">
    <h4 class="mb-8 mt-4 text-left text-dark-gray sm:mt-2">
      Enter your CLABE bank account information.
    </h4>
    <div class="md:grid md:grid-rows-2">
      <div class="w-full gap-4 md:flex">
        <form-field
          label="Account #"
          :value="account_number"
          placeholder="Enter 18 digit account #"
          :on-input="handleAccountNumber"
          :pattern="'number'"
          :show-check="false"
          name="clabe_number"
          :is-valid="!errors.account_number"
          :error-message="errors.account_number"
        />
        <form-field
          label="Re-Enter Account #"
          :value="verify_account_number"
          placeholder="Re-enter 18 digit account #"
          :on-input="handleVerify"
          :pattern="'number'"
          :show-check="false"
          name="clabe_verify_number"
          :is-valid="!errors.verify_account_number"
          :error-message="errors.verify_account_number"
        />
      </div>
      <div class="w-full gap-4 md:flex">
        <form-field
          label="Bank Name"
          :value="bank"
          placeholder="Bank name"
          :pattern="'number'"
          :show-check="false"
          :disabled="true"
          name="bank_name"
        />
        <form-field
          label="Bank City"
          :value="bank_city"
          placeholder="Bank city"
          :pattern="'number'"
          :show-check="false"
          :disabled="true"
          name="bank_city"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FormField from '@/components/FormField.vue';
import { clabe } from 'clabe-validator';

export default {
  name: 'ClabeForm',
  components: {
    'form-field': FormField,
  },
  props: {
    data: Object,
    firstTime: {
      type: [Number, Boolean],
      required: true,
    },
    stepName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      account_number: '',
      verify_account_number: '',
      bank: '',
      bank_city: '',
      errors: {
        account_number: '',
        verify_account_number: '',
      },
    };
  },
  computed: {
    isValidForm: function () {
      return (
        this.account_number.length == 18 &&
        this.verify_account_number.length == 18 &&
        !this.errors.account_number &&
        !this.errors.verify_account_number
      );
    },
  },
  watch: {
    isValidForm: function (isValid) {
      this.$store.commit('toggleDisabledButton', {
        bool: !isValid,
        source: 'Payment-3 ClabeForm #5',
      });

      if (isValid) {
        this.onUpdate();
      }
    },

    // stepName: function (val) {
    //   if (
    //     val === "Payment-3" &&
    //     ["ach", "wire"].includes(this.newPaymentMethodType)
    //   ) {
    //     if (
    //       this.account_number?.length > 0 &&
    //       this.routing_number?.length > 0 &&
    //       this.verify_account_number?.length > 0
    //     ) {
    //       this.onUpdate();
    //     } else {
    //       this.toggleButton(true);
    //     }
    //   }
    // },
  },
  mounted() {
    this.$store.commit(
      'addFormDebugMessage',
      'Payment-3 | ClabeForm | ClabeForm mounted'
    );
    if (!this.isValidForm) {
      this.$store.commit('toggleDisabledButton', {
        bool: true,
        source: 'Payment-3 ClabeForm #1',
      });
    } else {
      this.$store.commit('toggleDisabledButton', {
        bool: false,
        source: 'Payment-3 ClabeForm #2',
      });
    }
  },
  methods: {
    handleAccountNumber(e) {
      this.account_number = e.target.value;
      this.validateClabe();
    },
    handleVerify(e) {
      this.verify_account_number = e.target.value;

      // Determine if there is a mismatch or if the previous error can be cleared
      this.errors.verify_account_number =
        this.verify_account_number !== this.account_number
          ? 'The CLABE numbers provided do not match. Please ensure that both entries are identical and try again.'
          : '';
    },
    validateClabe() {
      if (this.account_number.length === 0) {
        this.bank = '';
        this.bank_city = '';
        this.errors.account_number = '';
        return;
      }

      const validation = clabe.validate(this.account_number);

      // Set bank and city from validation results if available
      this.bank = validation.bank || '';
      this.bank_city = validation.city || '';

      // Handle error messages
      this.errors.account_number = validation.error
        ? this.formatErrorMessage(validation.message)
        : '';
    },
    formatErrorMessage(message) {
      if (message.includes('Invalid checksum, last digit should be:')) {
        return 'Invalid control digit, please try again';
      }
      return message;
    },
    onUpdate() {
      let body = {
        is_active: true,
        account_number: this.account_number,
        is_type: 'clabe',
      };
      this.updateOnboardingPacket(body);
    },
    toggleButton(value) {
      this.$store.commit('toggleDisabledButton', {
        bool: value,
        source: 'Payment-3 ClabeForm #4',
      });
    },
    updateOnboardingPacket(body) {
      this.$store.dispatch('payments/setPaymentBody', {
        payment_method: body,
      });
    },
  },
};
</script>
